import { render, staticRenderFns } from "./VTableRowEmpty.vue?vue&type=template&id=d231a278&"
import script from "./VTableRowEmpty.vue?vue&type=script&lang=ts&"
export * from "./VTableRowEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./VTableRowEmpty.vue?vue&type=style&index=0&id=d231a278&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports